module.exports = __webpack_public_path__ + "static/videoHistoria-9bbda8a2e7db72a9560f2f51fda6bc83.mp4";